import { graphql, useStaticQuery } from 'gatsby'

import PricingSection from './pricing-section'
import React from 'react'

export default ({ locale }) => {
  const {
    allPricingYaml: { edges: data },
  } = useStaticQuery(graphql`
    {
      allPricingYaml {
        edges {
          node {
            id
            heading {
              cs
              en
            }
            services {
              cs
              en
              price {
                CZK
                EUR
                from
                per_tooth
              }
            }
          }
        }
      }
    }
  `)

  return data.map(({ node: { id, heading, services } }) => {
    return (
      <PricingSection
        heading={heading}
        key={id}
        locale={locale}
        services={services}
      />
    )
  })
}
